import { range } from 'lodash';

export const SCHEDULE_OPTIONS = [
  {
    value: 'HOURLY',
    label: 'schedule.duration.hourly'
  },
  {
    value: 'DAILY',
    label: 'schedule.duration.daily'
  },
  {
    value: 'WEEKLY',
    label: 'schedule.duration.weekly'
  },
  {
    value: 'MONTHLY',
    label: 'schedule.duration.monthly'
  },
  {
    value: 'MINUTES',
    label: 'schedule.duration.mins'
  }
];

export const WEEK_OPTIONS = [
  {
    value: 'FIRST',
    label: '1st week',
    type: 'WEEK_OF_MONTH'
  },
  {
    value: 'SECOND',
    label: '2nd week',
    type: 'WEEK_OF_MONTH'
  },
  {
    value: 'THIRD',
    label: '3rd week',
    type: 'WEEK_OF_MONTH'
  },
  {
    value: 'FOURTH',
    label: '4th week',
    type: 'WEEK_OF_MONTH'
  },
  {
    value: 'LAST',
    label: 'schedule.weekOptions.lastWeek',
    type: 'WEEK_OF_MONTH'
  }
];

export const DAY_OPTIONS = [
  { label: 'asset.runscript.day.monday', value: 'MONDAY' },
  { label: 'asset.runscript.day.tuesday', value: 'TUESDAY' },
  { label: 'asset.runscript.day.wednesday', value: 'WEDNESDAY' },
  { label: 'asset.runscript.day.thursday', value: 'THURSDAY' },
  { label: 'asset.runscript.day.friday', value: 'FRIDAY' },
  { label: 'asset.runscript.day.saturday', value: 'SATURDAY' },
  { label: 'asset.runscript.day.sunday', value: 'SUNDAY' }
];

export function getOrdinalSuffix(i) {
  const j = i % 10;
  const k = i % 100;
  if (j === 1 && k !== 11) {
    return `${i}st`;
  }
  if (j === 2 && k !== 12) {
    return `${i}nd`;
  }
  if (j === 3 && k !== 13) {
    return `${i}rd`;
  }
  return `${i}th`;
}

export const MONTH_DAY_OPTIONS = [
  ...range(1, 32).map((val) => ({
    label: `${getOrdinalSuffix(val)} day`,
    value: `${val}`,
    type: 'DAY_OF_MONTH'
  })),
  ...[{ label: 'schedule.month.day.lastDay', value: '0', type: 'DAY_OF_MONTH' }]
];

export const SCHEDULE_ENDTYPE = {
  AFTERNHOURS: 'AfterNHours',
  AFTTERNDAYS: 'AfterNDays',
  AFTERNRUNS: 'AfterNRuns',
  AFTERDATETIME: 'AfterDateTime',
  NEVER: 'Never'
};

export const SCHEDULE_STARTTYPE = {
  IMMEDIATE: 'IMMEDIATE',
  STARTDATE: 'SCHEDULE'
};

export const END_OPTION = [
  {
    value: SCHEDULE_ENDTYPE.AFTERNRUNS,
    label: 'admin.schedule.end.option.after'
  },
  {
    value: SCHEDULE_ENDTYPE.AFTERDATETIME,
    label: 'admin.schedule.end.option.date'
  },
  {
    value: SCHEDULE_ENDTYPE.NEVER,
    label: 'admin.schedule.end.option.never'
  }
];

export const HOUR_OPTIONS = [
  { label: '12:00', value: '12:00' },
  { label: '12:30', value: '12:30' },
  { label: '1:00', value: '1:00' },
  { label: '1:30', value: '1:30' },
  { label: '2:00', value: '2:00' },
  { label: '2:30', value: '2:30' },
  { label: '3:00', value: '3:00' },
  { label: '3:30', value: '3:30' },
  { label: '4:00', value: '4:00' },
  { label: '4:30', value: '4:30' },
  { label: '5:00', value: '5:00' },
  { label: '5:30', value: '5:30' },
  { label: '6:00', value: '6:00' },
  { label: '6:30', value: '6:30' },
  { label: '7:00', value: '7:00' },
  { label: '7:30', value: '7:30' },
  { label: '8:00', value: '8:00' },
  { label: '8:30', value: '8:30' },
  { label: '9:00', value: '9:00' },
  { label: '9:30', value: '9:30' },
  { label: '10:00', value: '10:00' },
  { label: '10:30', value: '10:30' },
  { label: '11:00', value: '11:00' },
  { label: '11:30', value: '11:30' }
];

export const MEREDIAN_OPTIONS = [
  { label: 'AM', value: 'AM' },
  { label: 'PM', value: 'PM' }
];

export const tableHeaders = [
  {
    name: 'ITEM',
    label: 'client.contractTemplate.invoiceItems.table.item',
    accessor: 'name'
  },
  {
    name: 'FREQUENCY',
    label: 'client.contractTemplate.invoiceItems.table.frequency',
    accessor: 'frequency',
    subAccessor: 'unit'
  },
  // {
  //   name: 'SUBSCRIPTION',
  //   label: 'client.contractTemplate.invoiceItems.table.subscription',
  //   accessor: 'subscriptionType'
  // },
  {
    name: 'EFFECTIVE_DATE',
    label: 'client.contractTemplate.invoiceItems.table.effectiveDate',
    accessor: 'effectiveDate'
  },
  {
    name: 'END_DATE',
    label: 'client.contractTemplate.invoiceItems.table.endDate',
    accessor: 'endDate'
  },
  {
    name: 'QUANTITY',
    label: 'client.contractTemplate.invoiceItems.table.quantity',
    accessor: 'quantity'
  },
  {
    name: 'UNIT_PRICE',
    label: 'client.contractTemplate.invoiceItems.table.unitPrice',
    accessor: 'unitPrice'
  },
  {
    name: 'TOTAL',
    label: 'client.contractTemplate.invoiceItems.table.total',
    accessor: ''
  },
  {
    name: 'ACTIONS',
    label: '',
    accessor: ''
  }
];

export const REVENUE_METRICS = [
  {
    name: 'profit',
    label: 'msp.client.details.revenue.widget.overall.profit',
    type: 'CURRENCY'
  },
  {
    name: 'revenue',
    label: 'msp.client.details.revenue.widget.revenue.total',
    type: 'CURRENCY'
  },
  {
    name: 'monthlyRecurringRevenue',
    label: 'msp.client.details.revenue.widget.revenue.monthly.recuring',
    type: 'CURRENCY'
  }
];
